import { motion } from "framer-motion";
import { usePrefersReducedMotion } from "../lib/useReducedMotion";

// Word-by-word masked reveal for headings.
export function SplitReveal({ text, className = "", delay = 0, as: Tag = "h2", stagger = 0.08 }) {
  const reduced = usePrefersReducedMotion();
  const words = Array.isArray(text) ? text : String(text).split(" ");

  if (reduced) {
    return <Tag className={className}>{words.join(" ")}</Tag>;
  }

  return (
    <Tag className={className} aria-label={words.join(" ")}>
      {words.map((word, i) => (
        <span key={i} className="inline-block overflow-hidden align-bottom" aria-hidden="true">
          <motion.span
            className="inline-block"
            initial={{ y: "110%" }}
            whileInView={{ y: "0%" }}
            viewport={{ once: true, margin: "-10% 0px" }}
            transition={{ duration: 0.75, ease: [0.16, 1, 0.3, 1], delay: delay + i * stagger }}
          >
            {word}
            {i < words.length - 1 ? "\u00A0" : ""}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

export function FadeUp({ children, delay = 0, className = "", y = 24 }) {
  const reduced = usePrefersReducedMotion();
  if (reduced) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10% 0px" }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay }}
    >
      {children}
    </motion.div>
  );
}
